import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aca07c188d2d0e5a85a6b3ac3454b0891b from "./generated-62d8a5d5-74d9-46c2-9898-9f58c4c45082.json";

import aa653b3bdd69d6dda9d0a589bc3d89c46b from "./generated-9d5d3103-a576-4b10-b106-77854ae485b3.json";

import a3f0fabe7c7aba9df3037cce652a7cb75b from "./generated-bde3ebf7-b70c-4f71-b2df-4cdc9cf86c33.json";

import a40dcd142aa7f37882ff16e32293cf104b from "./generated-397b3828-3c99-49cd-b197-d618c1c71b07.json";

import a877fe3a77cbfd05450b9586e9b81536ab from "./generated-4c9d203d-ecac-4748-a858-b8ecb94c14fc.json";

import abc91fa273c8a76f48c59183f97a600ccb from "./generated-aa0e9d82-9955-4d24-a24f-a09222621155.json";

import ac79a6bbeb5cf2c735dd2e91cec0b200db from "./generated-4413388f-520b-4bcc-aa08-b5105f5ae20a.json";

import a62100653a4be00fc64e9f098cbb59da5b from "./generated-36ed9d26-2222-4971-87d0-1452f45eb9a2.json";

import a27b1e44f47e90d46ba44a95a002ddc72b from "./generated-7f2286e5-ba5c-4da4-9470-bea2dfb239ee.json";

import a40a1204c46c10c69e38edb4f382bf9c9b from "./generated-81dce7ff-3908-4608-856c-4edf52b01202.json";

import a13c1a71f774363a21fc1ce3ab177dae8b from "./generated-940616f9-c281-4044-a103-7827ec1e8b1a.json";

import a561f95538120a29b41b42d948a899d81b from "./generated-b24bcdff-d4cd-463b-acdc-21dbd760cbd7.json";

import a6f88623cf5ed1083597e4cc196bf8117b from "./generated-1d2a3cc3-9e76-468b-8b11-20fb24bdbc72.json";

import a8449fc6a17b0e859aaa6e5dfcab7e31db from "./generated-ffcd8e48-36b7-42b3-896e-ada049b8d9ad.json";

import a5d1465faec975a1d6fd7fa4449aed31eb from "./generated-49c9dc5e-3d2e-464f-9704-da4d5bf0775a.json";

import abb986491ddfe3ab9cdce27558f632231b from "./generated-d956c3eb-4aba-4c79-973b-72c759345704.json";

import a86bf413b7c32b7b1072b868dc772aae4b from "./generated-2966e1f0-82e0-4d96-9fa0-c27a2954587f.json";

import ac926f7ded412bb3d1f3a4f2f9e875ba2b from "./generated-088891dd-f19f-4a33-b770-4bd2f912b8e7.json";

import a4a331668f659e8948b5dd4ca3337fe27b from "./generated-37a9a162-8acc-482c-a7ca-1e4b4d155543.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aca07c188d2d0e5a85a6b3ac3454b0891b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aa653b3bdd69d6dda9d0a589bc3d89c46b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a3f0fabe7c7aba9df3037cce652a7cb75b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a40dcd142aa7f37882ff16e32293cf104b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a877fe3a77cbfd05450b9586e9b81536ab);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(abc91fa273c8a76f48c59183f97a600ccb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac79a6bbeb5cf2c735dd2e91cec0b200db);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a62100653a4be00fc64e9f098cbb59da5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a27b1e44f47e90d46ba44a95a002ddc72b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a40a1204c46c10c69e38edb4f382bf9c9b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a13c1a71f774363a21fc1ce3ab177dae8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a561f95538120a29b41b42d948a899d81b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a6f88623cf5ed1083597e4cc196bf8117b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a8449fc6a17b0e859aaa6e5dfcab7e31db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a5d1465faec975a1d6fd7fa4449aed31eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(abb986491ddfe3ab9cdce27558f632231b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a86bf413b7c32b7b1072b868dc772aae4b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ac926f7ded412bb3d1f3a4f2f9e875ba2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a4a331668f659e8948b5dd4ca3337fe27b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a86bf413b7c32b7b1072b868dc772aae4b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */